import { render, staticRenderFns } from "./CamposConfiguracion.vue?vue&type=template&id=1feb30b3&scoped=true&"
import script from "./CamposConfiguracion.vue?vue&type=script&lang=js&"
export * from "./CamposConfiguracion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feb30b3",
  null
  
)

export default component.exports